import comp from '../components/barrel';

export default {
  application_uuid: null,
  marriages: null,
  party1_name: null,
  party2_name: null,
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;
    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-maritial-detail', vars));
    this.recipe.methods.push(await O.mPOST('communal/marriages', vars));
  },
  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const MarriageData = data[`application/get-maritial-detail`].data;
    this.marriages = data[`communal/marriages`].data;
    
    // Build array of all parties that exist
    const parties = [
      { key: 'party1', data: MarriageData.party1 },
      { key: 'party2', data: MarriageData.party2 },
      { key: 'party3', data: MarriageData.party3 },
      { key: 'party4', data: MarriageData.party4 },
      { key: 'party5', data: MarriageData.party5 }
    ];

    // Create form sections for all parties
    for (let i = 0; i < parties.length; i++) {
      const party = parties[i];
      if (party.data && party.data.full_name) {
        const partyNumber = i + 1;
        const partyKey = party.key;
        const partyId = partyKey.replace('party', ''); // party1 -> 1, party2 -> 2, etc.
        
        const div = U.divAtt('div', 'class', 'mb-4');
        const heading = U.divAtt('div', 'class', 'mb-2');
        heading.innerHTML = `Party ${partyNumber}: ${party.data.full_name}`;
        div.appendChild(heading);
        
        let marriageDD = await comp.select(`${partyKey}Marriage`, this.marriages, 'marriage_uuid', 'short_text', 'Marriage Status', 1);
        div.appendChild(marriageDD);
        await U.id('marriageForm').appendChild(div);
        
        // Set value if marriage_uuid exists
        if (party.data.marriage_uuid) {
          U.id(`${partyKey}Marriage`).value = party.data.marriage_uuid;
        }
      }
    }

    // Set up change handlers for all party marriage dropdowns
    setTimeout(() => {
      for (let i = 0; i < parties.length; i++) {
        const party = parties[i];
        if (party.data && party.data.full_name) {
          const partyKey = party.key;
          const marriageSelect = U.id(`${partyKey}Marriage`);
          if (marriageSelect) {
            if (party.data.marriage_uuid) {
              marriageSelect.value = party.data.marriage_uuid;
            }
            marriageSelect.setAttribute('onchange', `thsSubTab.updateMarriage()`);
          }
        }
      }
    }, 1000);
  },
  async updateMarriage() {
    let isValid = await U.validateForm('marriageForm');
    if (!isValid) {
      return;
    }

    const vars = {};
    vars.application_uuid = this.application_uuid;
    
    // Get marriage UUIDs for all parties that exist
    const parties = ['party1', 'party2', 'party3', 'party4', 'party5'];
    for (const partyKey of parties) {
      const marriageSelect = U.id(`${partyKey}Marriage`);
      if (marriageSelect) {
        const varKey = `${partyKey}_marriage_uuid`;
        vars[varKey] = marriageSelect.value;
      }
    }

    O.PREP([await O.mPOST('application/ups-maritial-detail', vars)])
      .then(async (res) => {
        const msg = res['application/ups-maritial-detail'].status;
        comp.toast(msg);
      })
      .catch(() => {});
  },
  async savePage(nextPrev) {
    const method = 'application/val-app-page';
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.page_name = 'ADs_MaritalStatus';
    O.PREP([await O.mPOST(method, vars)])
      .then(async (res) => {
        comp.toast(res[method].status);
        thsPage.pageProgress(res[method].data, nextPrev);
      })
      .catch(() => {});
  },
};
